import { sendPost } from './axios';

export const login = (params) => sendPost('/login', params);
